const cache = new Map<string, string>();

/**
 * Fetches content from an S3 presigned URL, caching the result.
 * Used for lazy-loading large step text/output that was offloaded to S3.
 */
export async function fetchOffloadedContent(url: string): Promise<string> {
  const cached = cache.get(url);
  if (cached !== undefined) return cached;
  const res = await fetch(url);
  if (!res.ok) throw new Error('Content unavailable');
  const text = await res.text();
  cache.set(url, text);
  return text;
}
